import { render, staticRenderFns } from "./PeopleSportEdit.vue?vue&type=template&id=4156aaac&scoped=true"
import script from "./peopleSportEdit.js?vue&type=script&lang=js&external"
export * from "./peopleSportEdit.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4156aaac",
  null
  
)

export default component.exports